import { gql } from "graphql-request";

export const READ_PLAYBOOKS = gql`
  query ReadPlaybooks($tenantId: ID!) {
    readPlaybooks(tenantId: $tenantId) {
      id
      tenantId
      name
      objective
      description
      updatedAt

      items {
        id
        sopId
      }

      transitions {
        id
      }
    }
  }
`;

export const READ_PLAYBOOK = gql`
  query ReadPlaybook($id: ID!) {
    readPlaybook(id: $id) {
      id
      tenantId
      name
      objective
      description
      createdAt
      updatedAt

      items {
        id
        playbookId
        sopId
        sequence
        entryCriteria
        exitCriteria
        positionX
        positionY
        sop {
          id
          title
        }
      }

      transitions {
        id
        outcomeKey
        label
        isDefault

        fromPlaybookItem {
          id
          sequence

          sop {
            id
            title
          }
        }

        toPlaybookItem {
          id
          sequence

          sop {
            id
            title
          }
        }
      }
    }
  }
`;